const SvgOrangeHomeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#F69133"
      stroke="#F79133"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.523 3.313-6.288 4.9c-1.05.817-1.902 2.555-1.902 3.874v8.645c0 2.706 2.205 4.923 4.912 4.923h13.51c2.706 0 4.911-2.217 4.911-4.912V12.25c0-1.412-.945-3.22-2.1-4.025l-7.21-5.052c-1.633-1.143-4.258-1.085-5.833.14"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14 20.988v-3.5"
    />
  </svg>
);
export default SvgOrangeHomeIcon;
